import { Performer } from '../../core/performer'
import { HttpMethod } from '../../core/types'
import type { RegisterRequest } from './model'

export class Register extends Performer<
  {
    payload: RegisterRequest
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/auth/register'
}

export default new Register().perform
